import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const AlignItemsLeft = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          d="M2.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5ZM5 6.5V3h8v3.5H5ZM4 3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3.5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3Zm1 6.5V13h4V9.5H5Zm0-1a1 1 0 0 0-1 1V13a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V9.5a1 1 0 0 0-1-1H5Z"
          clipRule="evenodd"
        />
      </svg>
    )
  },
)

export default AlignItemsLeft
